module.exports = __webpack_public_path__ + "img/c60a2db.svg";